import subheader from './subheader';
import body from './body';

export default {
	subheader,
	body
};
